import { render, staticRenderFns } from "./AgreementPreContract.vue?vue&type=template&id=6cbc16da&scoped=true&"
import script from "./AgreementPreContract.vue?vue&type=script&lang=ts&"
export * from "./AgreementPreContract.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementPreContract.vue?vue&type=style&index=0&id=6cbc16da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc16da",
  null
  
)

export default component.exports